export enum USER_ROLES_ENUM {
  CLIENT = "client",
  FREELANCER = "freeLancer",
  AGENCY = "agency",
}

export enum ROLES_ENUM {
  CLIENT = "client",
  FREELANCER = "freeLancer",
  AGENCY = "agency",
  SUPER_ADMIN = "superAdmin",
  ADMIN = "admin",
}

export const ShopAccessRoles = [USER_ROLES_ENUM.CLIENT];

export const ProfessionalRoles = [USER_ROLES_ENUM.FREELANCER, USER_ROLES_ENUM.AGENCY];
